import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { Subject, Subscription, forkJoin } from "rxjs";
import { ReadDefaultValuesPopupComponent } from "../read-default-values-popup/read-default-values-popup.component";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";

import { FEATURE_PATTERNS, FEATURE_NORMALIZATION } from '../../constants/supported-features-constant';
import {environment} from "../../../../environments/environment";
import { AvailableFeaturesStateService } from "../../../core-module/services/state/available-features-state.service";
import { CorruptFeaturesService } from "../../../core-module/services/state/corrupt-features.service";
import { FeatureUtilsService } from "../../../core-module/services/state/feature-utils.service";
import { MtpExtrasStateService } from "../../../core-module/services/state/mtp-extras-state.service";
import { MultiOneHttpClient } from "../../../core-module/services/state/multi-one-http-client.service";
import { UiSignalsStateService } from "../../../core-module/services/state/ui-signals-state.service";
import {
  DEVICE_SEARCH_ENDPOINT,
  DEVICE_SEARCH_QUERY_PREFIX,
  PRIMARY_DEVICE_REGIONS,
} from "../../constants/configure-device-modal.constants";

const BOX_RESULTS_DISPLAY_MS = 750;

@Component({
  standalone: false,
  selector: "app-supported-features-multi",
  templateUrl: "./supported-features.component-multi.html",
  styleUrls: ["./supported-features.component-multi.scss"],
})
export class SupportedFeaturesComponentMulti implements OnInit, OnDestroy {
  @Input() public retryClicked;
  @Input() public initialCount:LegacyAny=0;
  @Input() public outOfCount=24;
  @Input() public isFailed: boolean = false;
  retryImg: boolean = false;
  allFeatures = [];
  hidePrevFeat: boolean = false;
  combineAllFeat: LegacyAny = [];
  finalIndex = 0;
  FinalArray = [];
  unsubscribe = new Subject<void>();
  envScehmaLIstApi: LegacyAny;
  countRedGreen: LegacyAny = 0;
  subscription: Subscription;
  deviceInfo: LegacyAny;
  startConfigurationData: LegacyAny;
  allFeaturesOFDevice = {};
  invertedImg: boolean = false;
  greenArray = [];
  redArray = [];
  orangeArray = [];
  regions: string[];
  searchName: LegacyAny[];
  apiList: LegacyAny = [];
  fullDeviceList = DEVICE_SEARCH_ENDPOINT;
  envDeviceListURL: string;
  url: LegacyAny;
  customerLoader: boolean = false;
  contniueBtnClicked: boolean = false;
  pathVal:string;
  availableFeatureSub:Subscription;
  private boxResultsTimeoutId?: ReturnType<typeof setTimeout>;
  // Backward-compatible facade for legacy specs expecting `apiService`.
  apiService: LegacyAny;
  constructor(
    
    private modalService: NgbModal,
    public route: Router,
    public activemodal: NgbActiveModal,
    private appState: AppStateService,
    private utils: FeatureUtilsService,
    private availFeat: AvailableFeaturesStateService,
    private corruptFeatures: CorruptFeaturesService,
    private mtpExtras: MtpExtrasStateService,
    private uiSignals: UiSignalsStateService,
    private httpClient: MultiOneHttpClient
  ) {
    this.apiService = {
      getImageUrl: (host: string) => this.utils.getImageUrl(host),
      getAvailableFeatureMulti: this.availFeat.getAvailableFeatureMulti,
      nonCorrupt: this.corruptFeatures.nonCorrupt,
      corruptFeat: this.corruptFeatures.corruptFeat,
      getRedFeature: this.corruptFeatures.getRedFeature,
      renameFeatures: (arr: LegacyAny[]) => this.utils.renameFeatures(arr),
      sendFeatures: (data: LegacyAny) => this.availFeat.sendFeatures(data),
      sendCorruptFeat: (data: LegacyAny) => this.corruptFeatures.sendCorruptFeat(data),
      sendNonCorrupt: (data: LegacyAny) => this.corruptFeatures.sendNonCorrupt(data),
      sendShowNextSuccessBtnMulti: (data: LegacyAny) => this.mtpExtras.sendShowNextSuccessBtnMulti(data),
      modalClose: (data: LegacyAny) => this.uiSignals.modalClose(data),
      apiCall: (method: string, url: string, body?: LegacyAny, options?: LegacyAny) => this.httpClient.apiCall(method, url, body, options),
    };
  }

  private extractFeatures(data: LegacyAny[]): string[] {
    const features = new Set<string>();
    for (const element of data) {
      const val = element.toString();
      for (const feat of FEATURE_PATTERNS) {
        if (feat.exclude && feat.exclude.test(val)) continue;
        if (feat.pattern.test(val)) {
          if (feat.unique && features.has(feat.name)) continue;
          features.add(feat.name);
        }
      }
    }
    return Array.from(features).sort((a, b) => a.localeCompare(b));
  }

  private normalizeFeatureName(name: string): string {
    const lower = name.toLowerCase();
    if (/^luminfoformat\d*-?$/.test(lower)) return "Luminaire Info";
    return FEATURE_NORMALIZATION[lower] || name;
  }

  ngOnInit() {
    this.pathVal = this.apiService.getImageUrl(window.location.hostname);
    this.apiService.getAvailableFeatureMulti.subscribe((data: LegacyAny) => {
      if (Array.isArray(data) && data.length > 0) {
        this.hidePrevFeat = true;
        this.allFeatures = this.extractFeatures(data);
        this.invertedImg = !!this.appState.getIsWriting();
        this.allFeaturesOFDevice = {
          selectedFeature: this.allFeatures,
          allFeature: data,
        };
        this.appState.setSupportedFeatures(this.allFeaturesOFDevice);
      } else {
        this.allFeatures = [];
      }
    });

    this.apiService.nonCorrupt.subscribe(() => {});
    this.apiService.corruptFeat.subscribe(() => {});
    this.apiService.getRedFeature.subscribe(() => {});
  }

  ngDoCheck() {
    const data = this.appState.getResultFeatures();
    if (data) {
      if (this.appState.getReaderDeviceFullInfo()) {
        this.deviceInfo = this.appState.getReaderDeviceFullInfo();
      }
      if (Array.isArray(data.green)) {
        data.green = data.green
          .map(item => {
            if (Array.isArray(item)) {
              const filtered = item.filter(
                el => !["codedlight"].includes(String(el).toLowerCase())
              );
              return filtered.length > 0 ? filtered : null;
            }
            if (typeof item === "string" && ["codedlight"].includes(item.toLowerCase())) {
              return null;
            }
            return item;
          })
          .filter(Boolean);
        this.appState.setResultFeatures(data);
      }

      const normalize = (el: LegacyAny) => this.normalizeFeatureName(el);

      const processArray = (arr: LegacyAny[]) =>
        [].concat(
          ...arr
            .filter(Boolean)
            .map(el => {
              if (Array.isArray(el)) {
                return el.map(e => normalize(e));
              }
              return normalize(el);
            })
        );

      const unique = (arr: string[]) => Array.from(new Set(arr));

      this.orangeArray = unique(processArray(data["orange"] || []));
      // Green features: handle interdependent features
      const greenFeat: string[] = [];
      (data["green"] || []).forEach((element) => {
        if (element) {
          const normalized = Array.isArray(element)
            ? element.map(e => e.toLowerCase())
            : [element.toLowerCase()];
          if (
            normalized.length > 1 &&
            (normalized.includes("dynadimmer") ||
              normalized.includes("lineswitch") ||
              normalized.includes("codedmains") ||
              normalized.includes("ampdim"))
          ) {
            normalized.forEach((interdepFeat) => {
              greenFeat.push(this.normalizeFeatureName(interdepFeat));
            });
          } else {
            greenFeat.push(this.normalizeFeatureName(normalized[0]));
          }
        }
      });
      this.greenArray = unique(greenFeat);

      // Red features
      const redFeat: string[] = [];
      (data["red"] || []).forEach((element) => {
        if (element) {
          for (let i = 0; i < element.length; i++) {
            const feat = element[i].featureName?.toLowerCase();
            redFeat.push(this.normalizeFeatureName(feat));
          }
        }
      });
      this.redArray = unique(redFeat);

      if(this.greenArray.length > 0 || this.redArray.length > 0 || this.orangeArray.length > 0) {
        this.appState.removeResultFeatures();
        this.appState.removeCorruptMemoryBankId();
        this.concatFeat();
      }
    }
  }

  concatFeat() {
    this.customerLoader = true;
    this.hidePrevFeat = false;
    this.retryImg = true;
    const green = [];
    const red = [];
    const orange = [];
    // this.apiService.getEnvValue();
    // this.apiService.getEnvData
    //   .pipe(takeUntil(this.unsubscribe))
    //   .subscribe((url) => {
    //     if (url.length > 0) {
    //       this.url = url;
    //     }
    //   });
    this.url = environment.multiOneAPIUrl;
    // special condtion only for cloLite
    this.greenArray = this.apiService.renameFeatures(this.greenArray);
    const commonOrange = this.greenArray.filter((item) =>
      this.orangeArray.includes(item)
    );
    commonOrange.forEach((element) => {
      // AOC, CLO
      if (element) {
        orange.push({ name: element, flag: "orange" });
      }
    });
    for (let i = 0; i < this.greenArray.length; i++) {
      for (let j = 0; j < orange.length; j++) {
        if (this.greenArray[i] === orange[j]["name"]) {
          this.greenArray.splice(i, 1);
        }
      }
    }
    this.greenArray.forEach((element) => {
      // CLO
      if (element) {
        green.push({ name: element, flag: "green" });
      }
    });
    // Failed Feature Array
    this.redArray = this.apiService.renameFeatures(this.redArray);
    this.redArray.forEach((element) => {
      // ALO
      if (element) {
        red.push({ name: element, flag: "red" });
      }
    });
    this.FinalArray = green.concat(orange).concat(red);
    const allFeat = this.appState.getSupportedFeatures();
    const filterRedFeatures = allFeat["selectedFeature"].filter(
      (item) => this.greenArray.indexOf(item) < 0
    );
    if (this.FinalArray.length > 0) {
      this.sort(this.FinalArray);
    }
    clearTimeout(this.boxResultsTimeoutId);
    this.combineAllFeat = [...this.FinalArray];
    this.finalIndex = this.FinalArray.length;
    this.boxResultsTimeoutId = setTimeout(() => {
      const config = this.appState.getReaderConfigurationData();
      this.finalIndex++;
      if (this.deviceInfo) {
        this.getReaderValue(config);
      } else {
        this.searchWith12Nc(config);
      }
    }, BOX_RESULTS_DISPLAY_MS);
  }

  getReaderValue(config) {
    // this.apiService.getEnvValue();
    // this.subscription = this.apiService.getEnvData
    //   .pipe(takeUntil(this.unsubscribe))
    //   .subscribe((url) => {
    //     if (url.length > 0) {
    //       this.unsubscribe.next();
    this.customerLoader = false;
    this.apiService.sendShowNextSuccessBtnMulti(true);

      //   }
      // });
  }

  continueBtnClickedOP() {
    if (this.contniueBtnClicked) {
      this.apiService.modalClose("close");
      this.activemodal.close();
      this.appState.setNormalFlow(false);

      this.route.navigate(["/featureLanding"]);
    }
  }
  sort(items) {
    items.sort(function (a, b) {
      return a.name - b.name || a.name.localeCompare(b.name);
    });
  }

  searchWith12Nc(searchText) {
    let j = 0;
    this.regions = [...PRIMARY_DEVICE_REGIONS];
    this.regions.forEach((element) => {
      this.searchTextValue(searchText.device12nc, {}, j);
      j++;
    });

    this.unsubscribe.next(undefined);
    this.searchName = [];
    const config = this.appState.getReaderConfigurationData();
    forkJoin(this.apiList).subscribe((resp) => {
      this.deviceInfo = [].concat.apply([], resp);
      this.appState.setReaderDeviceFullInfo(this.deviceInfo);
      this.getReaderValue(config);
    });
  }

  searchTextValue(searchText, headers?, j?) {
    if (this.url.length) {
      this.envDeviceListURL = `${this.url}${this.fullDeviceList}?device12nc=`;
      this.unsubscribe.next(undefined);
      this.apiList[j] = this.apiService.apiCall(
        "get",
        `${this.envDeviceListURL}${searchText}&showArchive=true`,
        "",
        { headers: headers }
      );
    }
  }

  ngOnDestroy() {
    clearTimeout(this.boxResultsTimeoutId);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.apiService.sendFeatures("");
    this.apiService.sendCorruptFeat("");
    this.apiService.sendNonCorrupt("");
    if (this.availableFeatureSub) {
      this.availableFeatureSub.unsubscribe();
    }
  }
}

